import { z } from 'zod';
import { componentStyleSchema } from '../component-catalog.js';
const commonOptionals = {
    queryConfig: z.record(z.string(), z.unknown()).optional(),
    minimized: z.boolean().optional(),
    displayConfig: z.record(z.string(), z.unknown()).optional(),
    annotations: z.array(z.record(z.string(), z.unknown())).optional(),
    style: componentStyleSchema.optional(),
};
const propsSchema = z
    .object({
    sourceDataset: z.string(),
    mapping: z
        .object({
        x: z.string(),
        y: z.union([z.string(), z.array(z.string())]),
        groupBy: z.string().optional(),
    })
        .strict(),
    ...commonOptionals,
})
    .strict();
export const barChartDefinition = {
    type: 'BarChart',
    category: 'data',
    propsSchema,
    isDataBacked: true,
    columnRefManifest: ['x', 'y', 'groupBy'],
    needsMeasuredDims: true,
    defaultMinHeight: 200,
    description: 'Bar chart over a dataset. Props: sourceDataset (required), mapping ({ x: string, y: string | string[], groupBy?: string }).',
};
//# sourceMappingURL=BarChart.js.map